function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useFormikContext } from 'formik';
import { groupBy } from 'lodash';
import { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
export function useTreatmentForm(routes, treatments) {
  var _query$get;

  var history = useHistory();
  var location = useLocation();
  var query = new URLSearchParams(location.search);
  var initialValues = {
    treatment: (_query$get = query.get('service')) !== null && _query$get !== void 0 ? _query$get : '',
    addons: {}
  };

  function onSubmit(values) {
    var treatment = treatments.find(function (t) {
      return t.value === values.treatment;
    });
    var addons = groupBy(treatment.addons, 'value');
    var selectedAddons = Object.entries(values.addons).filter(function (_ref) {
      var key = _ref[0],
          value = _ref[1];
      return value === 'true';
    });
    var addonAggregateCost = selectedAddons.reduce(function (acc, _ref2) {
      var addon = _ref2[0];
      var _addons$addon = addons[addon],
          item = _addons$addon[0];
      return acc + item.cost;
    }, 0);
    var cost = treatment.cost + addonAggregateCost;
    var params = new URLSearchParams({
      cost: cost,
      treatment: values.treatment,
      addons: selectedAddons.map(function (_ref3) {
        var name = _ref3[0];
        return name;
      })
    });
    history.push({
      pathname: routes.paymentOptions,
      search: params.toString()
    });
  }

  return {
    initialValues: initialValues,
    onSubmit: onSubmit
  };
}
export function usePropagateTreatmentFormValues(treatments) {
  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue;

  useEffect(function updateAddonSelection() {
    if (!values.treatment) {
      setFieldValue('addons', {});
      return;
    }

    var treatment = treatments.find(function (t) {
      return t.value === values.treatment;
    });
    var defaults = treatment.addons.reduce(function (addons, opt) {
      var _extends2;

      return _extends({}, addons, (_extends2 = {}, _extends2[opt.value] = 'true', _extends2));
    }, {});
    setFieldValue('addons', defaults);
  }, [values.treatment, setFieldValue, treatments]);
}
export function useTreatmentFormAddon(treatments) {
  var _useFormikContext2 = useFormikContext(),
      values = _useFormikContext2.values;

  var selectedTreatmentValue = values.treatment;
  var selectedTreatment = useMemo(function () {
    if (!selectedTreatmentValue) {
      return null;
    }

    return treatments.find(function (t) {
      return t.value === selectedTreatmentValue;
    });
  }, [treatments, selectedTreatmentValue]);
  return {
    selectedTreatment: selectedTreatment,
    addOnTreatments: (selectedTreatment === null || selectedTreatment === void 0 ? void 0 : selectedTreatment.addons) || []
  };
}